import { render, staticRenderFns } from "./new-registered-athletes.vue?vue&type=template&id=dd1319b0&scoped=true&"
import script from "./new-registered-athletes.vue?vue&type=script&lang=js&"
export * from "./new-registered-athletes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1319b0",
  null
  
)

export default component.exports